module.exports = __webpack_public_path__ + "img/Chainsaf(4blur).30f32d33.jpg";